@import '../../shared';

.edu-text {
  @include container--content;
  margin-bottom: 3.2rem;

  &:last-child {
    margin-bottom: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 3.2rem;

    &:first-child {
      margin-top: 0;
    }
  }
}

.edu-text--note {
  font-size: $font-size-small;
  color: $text-color-secondary;
}

.edu-text--left,
.edu-text--right {
  margin: 1.5rem 0;
}

@media (min-width: $breakpoint-md) {
  .edu-text--left,
  .edu-text--right {
    margin-top: 0;
    margin-bottom: 1.5rem;
    max-width: 50%;
  }
  .edu-text--left {
    float: left;
    margin-right: 3.2rem;
  }
  .edu-text--right {
    float: right;
    margin-left: 3.2rem;
  }
}

.edu-column__contents,
.edu-list__item {
  > .edu-text {
    padding-left: 0;
    padding-right: 0;
  }
}

.edu-text__evidence-icon {
  height: 1.5rem;
  width: 1.5rem;
  vertical-align: middle;
  .edu-icon__tooltip-foreground {
    fill: $blue-text;
  }
  .edu-icon__tooltip-background {
    fill: $blue-background;
  }
}

.edu-text__evidence-button {
  vertical-align: text-bottom;
  margin-bottom: -0.2rem;
  cursor: pointer;
  h2 & {
    margin-bottom: 0.8rem;
  }

  h3 & {
    margin-bottom: 0.4rem;
  }

  h4 & {
    margin-bottom: 0;
  }
  &:hover {
    cursor: pointer;
    .edu-text__evidence-icon {
      .edu-icon__tooltip-foreground {
        fill: $blue-background;
      }
      .edu-icon__tooltip-background {
        fill: $blue-text;
      }
    }
  }
}

.edu-table__container {
  width: auto;
  max-width: $max-width-with-padding;
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-bottom: 3.2rem;
  overflow: scroll;
  display: block;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  @media (min-width: $breakpoint-md) {
    margin-left: auto;
    margin-right: auto;
  }
}

.edu-table {
  margin-left: auto;
  margin-right: auto;
  border-collapse: collapse;
  @media (min-width: $breakpoint-md) {
    width: 100%;
  }
  td,
  th {
    vertical-align: top;
    padding: 1.2rem 0.4rem;
    text-align: center;
    font-size: $font-size-small;
    @media (min-width: $breakpoint-md) {
      padding: 1.5rem 0.8rem;
      font-size: $font-size-default;
    }
  }
  thead th {
    vertical-align: bottom;
    background-color: $green-background;
    border-bottom: 0.2rem solid $green;
    font-weight: $font-weight-bold;
    line-height: 1;
  }
  td {
    border-bottom: 0.2rem solid $green-border;
  }
}

.edu-table--highlight {
  background-color: $yellow-background;
}
